import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeDateTimeInput from "../../components/inputs/NoticeDateTimeInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    root: {
    },
    dateTimeInput: {
        "width": 600
    }
}))

function OrderDetailsPartnership(
    {
        id,
        formikProps
    }) {
    const classes = useStyle();
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);

    return (<>
        <NoticeTypography formTrKey={id}/>

        <NoticeDateTimeInput
            formikProps={formikProps}
            id={gId("offerEndDate")}
            className={classes.dateTimeInput}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("offerSubmitPlace")}
            required
        />

        <NoticeDateTimeInput
            formikProps={formikProps}
            id={gId("offerOpenDate")}
            className={classes.dateTimeInput}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("phasedNegotiations")}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("suppliersLimited")}
            required
        />

        <Collapse in={gVal("suppliersLimited") === true}>

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("suppliersLimitedInfo")}
                required
            />

            <NoticeYesNoInput
                formikProps={formikProps}
                id={gId("criteriaComplianceDeclaration")}
                required
            />

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("criteriaComplianceList")}
                required
            />

            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("minSuppliersCount")}
                required
            />
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("maxSuppliersCount")}
                required
            />

        </Collapse>

    </>)
}

OrderDetailsPartnership.propTypes = {};

export default OrderDetailsPartnership;
